import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import {
  updateFormData,
  nextStep,
  prevStep,
  updatePrice,
  updatePage,
  resetForm,
} from "../../redux/formSlice";
import { Box, Typography } from "@mui/material";
import { addsettingsanad } from "../../services/sanad/sanad";
import Swal from "sweetalert2";

import PhotoSizeSelectLargeIcon from "@mui/icons-material/PhotoSizeSelectLarge";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import NoteIcon from "@mui/icons-material/Note";
import { useTranslation } from "react-i18next";
import StepNavigation from "../../components/StepNavigation";

function Orientartion() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { register, handleSubmit } = useForm();
  const formData = useSelector((state) => state.form.formData);
  const [settingsSaved, setSettingsSaved] = useState(false);

  const [selectedStatus] = useState(formData.status);
  const [selectedSize] = useState(formData.size);
  const [selectedType] = useState(formData.type);
  const [isFitPage, setisFitPage] = useState(formData.isFitPage);
  const [orientartion, setorientartion] = useState(formData.orientartion);

  const handleorientartionChange = (event) => {
    setorientartion(event.target.value);
  };

  const handleFitChange = (event) => {
    setisFitPage(event.target.value === "true");
  };

  const handleSanadSetting = async () => {
    const data = {
      papersize: selectedSize,
      statuschap: selectedStatus,
      typechap: selectedType,
      orientartion: Number(orientartion),
      isFitPage: Boolean(isFitPage),
    };

    try {
      const response = await addsettingsanad(data);
      const { price, nuberpage } = response.data.value;
      dispatch(updatePrice(price));
      dispatch(updatePage(nuberpage));
    } catch (err) {
      // Log the error for debugging
      console.error("Error submitting suggestion:", {
        message: err.message,
        status: err.response?.status,
        data,
        responseText: err.response?.data,
      });

      // Handle 400 status with plain text response
      let errorMessage = "Failed to submit suggestion";
      if (
        err.response?.status === 400 &&
        typeof err.response?.data === "string"
      ) {
        errorMessage = err.response.data; // Use plain text response from API
      } else if (err.response?.data?.message) {
        errorMessage = err.response.data.message; // Fallback for JSON responses
      } else if (err.message) {
        errorMessage = err.message; // Fallback to generic error message
      }

      throw new Error(errorMessage);
    }
  };
  const duration = formData.totalPages * 1300; // in ms
  const steps = 100; // total steps
  const intervalTime = duration / steps;
  const maxProgress = 98; // cap progress at 98%

  const onSubmit = (data) => {
    Swal.fire({
      title: t("Progress.Proccessing"),
      html: `
        <div id="progress-bar" style="width: 100%; background: #f1f1f1; border-radius: 5px; height: 15px; margin-top: 10px;">
          <div id="progress-fill" style="height: 100%; width: 0; background-color: #4caf50; border-radius: 5px;"></div>
        </div>
        <p id="progress-percentage" style="margin-top: 10px;">0%</p>
        <p id="page-number" style="margin-top: 5px;">  </p>
      `,
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      didOpen: () => {
        let progress = 0;
        const fill = document.getElementById("progress-fill");
        const percent = document.getElementById("progress-percentage");
        const pageNumber = document.getElementById("page-number");

        const interval = setInterval(() => {
          progress += maxProgress / steps;
          if (progress >= maxProgress) {
            progress = maxProgress;
            clearInterval(interval);
          }

          const currentPage = Math.min(
            formData.totalPages,
            Math.ceil((progress / maxProgress) * formData.totalPages)
          );

          fill.style.width = `${progress}%`;
          percent.innerText = `${Math.round(progress)}%`;
          pageNumber.innerText = `${t("Progress.Proccess")}  ${
            formData.totalPages
          } ${t("Progress.Page")}`;
        }, intervalTime);
      },
    });

    handleSanadSetting()
      .then(() => {
        Swal.fire({
          icon: "success",
          title: t("Progress.setting"),
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            title: "swal2-title-custom",
          },
        });
        setSettingsSaved(true); // Mark settings as saved
        dispatch(nextStep());
        dispatch(
          updateFormData({
            ...data,
            orientartion: orientartion,
            isFitPage: isFitPage,
          })
        );
        // Proceed to the next step
      })
      .catch((err) => {
        // Extract error message from the API response
        const errorMessage =
          err.response?.data || err.message || t("Progress.noDocfound");

        Swal.fire({
          title: t("Progress.settingerr"),
          text: errorMessage,
          confirmButtonText: t("Progress.ok"),
          customClass: {
            title: "swal2-title-custom",
          },
        });
        dispatch(resetForm());
      });
  };
  return (
    <Box
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "start",
        marginBottom: "3.5rem",
      }}
    >
      {/* Modern card-style scale selection */}
      <Box sx={{ mb: 2, width: "100%" }}>
        <Box sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h6" fontWeight={600}>
            {t("Upload.Scale")}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "space-between" }}>
          <Box
            sx={{
              flex: 1,
              p: 2,
              border: 2,
              borderColor: isFitPage === true ? "primary.main" : "grey.300",
              bgcolor:
                isFitPage === true ? "secondary.main" : "background.paper",
              color: isFitPage === true ? "white" : "text.primary",
              borderRadius: 2,
              cursor: "pointer",
              boxShadow: isFitPage === true ? 2 : 0,
            }}
            onClick={() => {
              setisFitPage(true);
              handleFitChange({ target: { value: "true" } });
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <AspectRatioIcon
                sx={{
                  fontSize: 32,
                  color: isFitPage === true ? "white" : "grey.700",
                }}
              />
              <Typography fontWeight={600}>{t("Upload.Fit")}</Typography>
            </Box>
          </Box>
          <Box
            sx={{
              flex: 1,
              p: 2,
              border: 2,
              borderColor: isFitPage === false ? "primary.main" : "grey.300",
              bgcolor:
                isFitPage === false ? "secondary.main" : "background.paper",
              color: isFitPage === false ? "white" : "text.primary",
              borderRadius: 2,
              cursor: "pointer",
              boxShadow: isFitPage === false ? 2 : 0,
            }}
            onClick={() => {
              setisFitPage(false);
              handleFitChange({ target: { value: "false" } });
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <PhotoSizeSelectLargeIcon
                sx={{
                  fontSize: 32,
                  color: isFitPage === false ? "white" : "grey.700",
                }}
              />
              <Typography fontWeight={600}>{t("Upload.Actual")}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Modern card-style orientation selection */}
      <Box sx={{ mb: 2, width: "100%" }}>
        <Box sx={{ mb: 1, display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="h6" fontWeight={600}>
            {t("Upload.Layout")}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 2, justifyContent: "space-between" }}>
          <Box
            sx={{
              flex: 1,
              p: 2,
              border: 2,
              borderColor: orientartion === 2 ? "primary.main" : "grey.300",
              bgcolor:
                orientartion === 2 ? "secondary.main" : "background.paper",
              color: orientartion === 2 ? "white" : "text.primary",
              borderRadius: 2,
              cursor: "pointer",
              boxShadow: orientartion === 2 ? 2 : 0,
            }}
            onClick={() => {
              setorientartion(2);
              handleorientartionChange({ target: { value: 2 } });
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <InsertDriveFileIcon
                sx={{
                  fontSize: 32,
                  color: orientartion == 2 ? "white" : "grey.700",
                }}
              />
              <Typography fontWeight={600}>{t("Upload.Portrait")}</Typography>
            </Box>
          </Box>

          <Box
            sx={{
              flex: 1,
              p: 2,
              border: 2,
              borderColor: orientartion === 1 ? "primary.main" : "grey.300",
              bgcolor:
                orientartion === 1 ? "secondary.main" : "background.paper",
              color: orientartion === 1 ? "white" : "text.primary",
              borderRadius: 2,
              cursor: "pointer",
              boxShadow: orientartion === 1 ? 2 : 0,
            }}
            onClick={() => {
              setorientartion(1);
              handleorientartionChange({ target: { value: 1 } });
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <NoteIcon
                sx={{
                  fontSize: 32,
                  color: orientartion == 1 ? "white" : "grey.700",
                }}
              />
              <Typography fontWeight={600}>{t("Upload.Landscape")}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <StepNavigation
        onBack={() => !settingsSaved && dispatch(prevStep())}
        onContinue={handleSubmit(onSubmit)}
        backLabel={t("Upload.Back")}
        continueLabel={t("Upload.Continue")}
        showBack={true}
        showContinue={true}
        continueDisabled={!selectedStatus || !selectedType}
        backDisabled={settingsSaved}
      />
    </Box>
  );
}

export default Orientartion;
